// extracted by mini-css-extract-plugin
export default {"header":"tEPTO","entryName":"QDyWk","stakeName":"nrVnc","matchName":"Iw8cn","nameError":"Epzoi","errorMessage":"tREXp","removeEntryButton":"jfH5s","datetime":"sfQit"};